import React from 'react';

import CustomButton from '../../custom-button/custom-btn.component';

import './navigation-card.styles.scss';
import { Loading } from 'carbon-components-react';

/*props=
image,
title,
textLabel
links={
    {icon,text,link},
    {icon,text,link}
}
buttonText

*/

const NavigationCard = ({
  children,
  title,
  subtitle = null,
  disabled = false,
  linkIcon1,
  linkIcon2,
  linkText1,
  linkText2,
  linkAction1 = null,
  linkAction2 = null,
  hideLink1 = false,
  hideLink2 = false,
  btnText,
  hideBtn = false,
  btnAction,
  isNew = false,
  isLoading = false,
}) => {
  return (
    <div className={`navigation-card bg-white`}>
      <div>
        <div className="top-content">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div className="icon">{children}</div>
            {isLoading && <Loading small={true} withOverlay={false} />}
            {isNew && (
              <span
                style={{
                  backgroundColor: 'green',
                  color: 'white',
                  padding: '4px 8px',
                  textAlign: 'center',
                  borderRadius: '5px',
                }}
                class="badge"
              >
                New
              </span>
            )}
          </div>
          <h3 className="title text-truncate">{title}</h3>
          {subtitle ? (
            <p className="subtitle text-truncate">{subtitle}</p>
          ) : (
            <div style={{ height: '24px' }} />
          )}
        </div>

        <div>
          <div hidden={hideLink1}>
            <hr className="line" />
            <button
              disabled={isLoading}
              className="text-truncate link pointer clear-btn"
              onClick={linkAction1}
            >
              {linkIcon1}&nbsp;{linkText1}
            </button>
          </div>

          <div hidden={hideLink2}>
            <hr className="line line2" />
            <button
              disabled={isLoading}
              className="text-truncate link pointer clear-btn"
              onClick={linkAction2}
            >
              {linkIcon2}&nbsp;{linkText2}
            </button>
          </div>
        </div>

        <div className="bottom" hidden={hideBtn}>
          <CustomButton
            classes="btn text-truncate"
            disabled={disabled}
            onClick={btnAction}
            isLoading={isLoading}
          >
            {btnText}
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

/* const NavigationCard = ({ image, title, textLabel, links, buttonText, classes, ...otherProps }) => (
  <div className={`navigation-card-container ${classes}`}
    {...otherProps}
  >
      <div>
          <img className="card-image" src={image} alt=""/>
          <p className="text-12 text-grey mt-20"> </p>
          <h3 className="text-23 text-dark">

          </h3>
      </div>
  </div>
);
 */
export default NavigationCard;
